import 'jquery';
import '../utils/slick.js';

$(function () {
    const list_st_logos = $(".slider-item-data-js");
    list_st_logos.slick({
        arrows: true,
        autoplay: true,
        cssEase: "linear",
        dots: false,
        infinite: true,
        slidesToShow: 1,

    });
});

function adjustElementHeight() {
    var rows = document.querySelectorAll('.row.list-item-data-js');
    rows.forEach(function (row) {
        var elements = row.querySelectorAll('.col-md-4 .detail-review-person');
        var h6elements = row.querySelectorAll('.col-md-4 .detail-data-title-review-h6');
        elements.forEach(function (element) {
            element.style.height = 'auto';
        });
        h6elements.forEach(function (element) {
            element.style.height = 'auto';
        });
        var maxHeight = 0;        
        h6elements.forEach(function (element) {
            var height = element.clientHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        h6elements.forEach(function (element) {
            element.style.height = maxHeight + 'px';
        });
        elements.forEach(function (element) {
            var height = element.clientHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        elements.forEach(function (element) {
            element.style.height = maxHeight + 'px';
        });
    });
}
adjustElementHeight();
window.addEventListener('resize', function () {
    adjustElementHeight();
});
